<template>
    <component
        :is="radioGroupLabelledBy ? 'fieldset' : 'div'"
        :aria-labelledby="radioGroupLabelledBy"
        class="sim-form-row"
        :class="{
            'sim-form-row--indented': indented,
            'sim-form-row--no-margin-bottom': noMarginBottom,
            'sim-form-row--wrap': wrap,
            'sim-form-row--vertical': orientation === 'vertical',
            'sim-form-row--horizontal': orientation === 'horizontal',
            'sim-form-row--1-1': ratio === '1/1',
            'sim-form-row--2-1': ratio === '2/1',
            'sim-form-row--auto': ratio === 'auto',
        }"
    >
        <slot />
    </component>
</template>

<script lang="ts" setup>

const {
    indented,
    noMarginBottom,
    wrap,
    orientation = 'auto',
    ratio,
    radioGroupLabelledBy,
} = defineProps<{
    indented?: boolean
    noMarginBottom?: boolean
    wrap?: boolean
    orientation?: 'horizontal' | 'vertical' | 'auto'
    ratio?: '1/1' |'2/1' | 'auto'
    /**
     * The HTML ID of the element that labels the radio group
     * inside this form row.
     *
     * Setting this prop will turn the wrapper div into a fieldset.
     */
    radioGroupLabelledBy?: string
}>()

// TODO: Add help, heading, description etc. (or maybe create a <FormGroup /> component?)

</script>

<style lang="scss" scoped>
.sim-form-row {
    display: flex;
    gap: 1.25rem;
    width: 100%;
    margin-bottom: 1rem;

    flex-direction: column;

    @include more-than(lg) {
        flex-direction: row;
    }
}

.sim-form-row--vertical.sim-form-row {
    flex-direction: column;
    gap: 1rem;
}

.sim-form-row--horizontal.sim-form-row {
    flex-direction: row;
}

.sim-form-row--wrap {
    flex-wrap: wrap;
    row-gap: 1rem;
}

.sim-form-row--indented {
    margin-top: 1.75rem;
}

.sim-form-row--no-margin-bottom {
    margin-bottom: 0;
}

.sim-form-row--2-1 {
    @include more-than(lg) {
        display: grid;
        grid-template-columns: 2fr 1fr;
    }
}

.sim-form-row--1-1 {
    @include more-than(lg) {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
}

.sim-form-row--auto {
    width: fit-content;
}
</style>
